import * as THREE from "three";
import { BufferGeometryUtils } from './BufferGeometryUtils';
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils'


const modelToMesh = async (gltfScene) => {

    let materials = []
    let geometries = []

    gltfScene.traverse(function (node) {
        let matrix = new THREE.Matrix4();

        if (node.isMesh) {
            materials.push(node.material);

            let mesh = SkeletonUtils.clone(node)

            const geometry = mesh.geometry;

            matrix.compose(node.position, node.quaternion, node.scale);
            // three.js r125+: applyMatrix заменён на applyMatrix4
            geometry.applyMatrix4(matrix);

            geometries.push(geometry);
        }
    });

    const mergedGeometry = BufferGeometryUtils.mergeBufferGeometries(geometries, true);
    const mergedMesh = new THREE.Mesh(mergedGeometry, materials);
    mergedMesh.castShadow = true;
    mergedMesh.receiveShadow = true;

    return mergedMesh;

}
export default modelToMesh;
